module.exports = __webpack_public_path__ + "img/rgb_active.9f762e21.png";